<template>
	<div>
		<v-progress-linear
			v-if="loading"
			class="ma-0 loading-bar"
			indeterminate
		/>
		<v-layout
			v-resize="onResize"
			:style="{ 'height': height }"
			row
		>
			<v-flex
				v-if="currentView <= 1"
				:md6="currentView === 1"
				class="edit-scrollable"
				xs12
				fill-height
			>
				<v-btn
					color="secondary"
					class="fixed--top-right"
					:disabled="loading"
					@click="$refs.articleForm.submit()"
				>
					Submit
				</v-btn>
				<ArticleForm
					ref="articleForm"
					:key="article.id"
					:edit-article="article"
					:edit="true"
					:extended="extended"
					:closable="closable"
					@edit-article="updateArticle"
					@close="$emit('close')"
				>
					<template slot="article-actions">
						<v-layout
							row
							wrap
							align-center
							class="mb-5"
						>
							<v-btn
								color="secondary"
								:disabled="loading"
								@click="article.refetchArticle()"
							>
								Refetch
							</v-btn>
							<v-btn
								color="primary"
								:disabled="loading"
								@click="showPublicationEditDialog = true"
							>
								Publication
							</v-btn>
							<v-btn
								color="primary"
								:disabled="loading"
								@click="article.updateSocialStats()"
							>
								Update Social Stats
							</v-btn>
							<v-btn
								v-if="$userCan('translate')"
								color="primary"
								:disabled="loading"
								@click="article.translateArticle()"
							>
								Translate
							</v-btn>
							<v-btn
								color="primary"
								:disabled="loading"
								@click="$emit('set-image', article)"
							>
								Set Image
							</v-btn>
							<v-btn
								color="primary"
								:disabled="loading"
								@click="$store.set('articlesBulkDialog/openArticleBulkDialog!', { action: 'move', articles: [article] })"
							>
								Move
							</v-btn>
							<v-btn
								color="primary"
								:disabled="loading"
								@click="$store.set('articlesBulkDialog/openArticleBulkDialog!', { action: 'copy', articles: [article] })"
							>
								Copy
							</v-btn>
							<v-btn
								color="error"
								:disabled="loading"
								@click="$store.set('articlesDeleteDialog/openArticleDeleteDialog!', [article])"
							>
								Delete
							</v-btn>
							<ArticleImportance
								class="ml-2"
								:article="article"
							/>
						</v-layout>
					</template>
					<v-btn
						slot="summary"
						small
						color="secondary"
						class="mx-0 mb-2 mt-3"
						:disabled="loading"
						@click="suggest = !suggest"
					>
						Suggest Summary from Keywords
					</v-btn>
				</ArticleForm>
			</v-flex>
			<v-flex
				v-if="currentView >= 1"
				:md6="currentView === 1"
				xs12
			>
				<div class="iframe-parent">
					<div class="iframe-failed">
						<h3 class="pa-4 text-xs-center">
							This feature is not available for this website, please selected "view in new tab".
						</h3>
					</div>
					<iframe
						v-if="iframeSrc !== ''"
						id="frame"
						ref="frame"
						:class="iframeClassName"
						:src="iframeSrc"
					/>
				</div>
			</v-flex>
		</v-layout>
		<v-bottom-nav
			:active.sync="currentView"
			:value="true"
			:absolute="closable"
			color="secondary"
			bottom
			dark
		>
			<v-btn
				:value="0"
				dark
				flat
			>
				<span>Edit</span>
				<v-icon>edit</v-icon>
			</v-btn>

			<v-btn
				v-if="$vuetify.breakpoint.mdAndUp"
				:value="1"
				dark
				flat
			>
				<span>Edit and View</span>
				<span><v-icon>edit</v-icon><v-icon>web_asset</v-icon></span>
			</v-btn>
			<v-btn
				:value="2"
				dark
				flat
			>
				<span>View</span>
				<v-icon>web_asset</v-icon>
			</v-btn>
		</v-bottom-nav>
		<v-btn
			v-if="$vuetify.breakpoint.mdAndUp"
			:href="article.url"
			dark
			flat
			target="_blank"
			class="position-end"
		>
			View in New Tab
			<v-icon
				small
				class="pl-2"
			>fa fa-external-link</v-icon>
		</v-btn>
		<KeywordSuggest v-model="suggest" :article="article"/>
		<PublicationEditDialog
			:show="showPublicationEditDialog"
			:article="article"
			@close="showPublicationEditDialog = false"
		/>
	</div>
</template>

<script>
import ArticleForm from '@/components/Article/ArticleForm';
import ArticleImportance from '@/components/Article/ArticleImportance';
import axios from '@/util/axios';
import { sync } from 'vuex-pathify';

export default {
	components: {
		ArticleForm,
		ArticleImportance,
		KeywordSuggest: () => import('./KeywordSuggest'),
		PublicationEditDialog: () => import('@/components/Publication/PublicationEditDialog'),
	},
	props: {
		extended: { default: true, type: Boolean },
		article: { type: Object, default: null },
		closable: { type: Boolean, default: true },
		singleEdit: { type: Boolean, default: false },
	},
	data() {
		return {
			loading: false,
			currentView: 0,
			height: 0,
			editHeight: 0,
			suggest: false,
			updateSocialStatsLoading: false,
			iframeSrc: '',
			iframeClassName: 'iframe-loading',
			showPublicationEditDialog: false,
		};
	},
	created() {
		// this.checkArticleUrl();
	},
	mounted() {
		this.onResize();
	},
	beforeDestroy() {
		this.article.reset();
	},
	computed: {
		articlesLoading: sync('events/articlesLoading'),
	},
	watch: {
		articlesLoading(val) {
			this.loading = val.changing;
			if (val.type === 'delete' || val.type === 'move') {
				this.$emit('close');
			}
		},
		currentView(newVal, oldVal) {
			if (newVal == 0) {
				this.iframeClassName = 'iframe-loading';
			}
			else if (newVal >= 1) {
				dump('currentView(newVal, oldVal)', newVal, oldVal);
				this.iframeSrc = this.article.url;
				window.setTimeout(() => {
					this.iframeClassName = '';
				}, 4000);
			}
		},
	},
	methods: {
		updateArticle(custom, article) {
			this.loading = true;
			article.customData = custom;
			article.save().then(() => {
				this.$notify('success', `Article "${article.title}" has been updated.`);
			}).catch(() => {
				this.$notify('error', `Article "${article.title}" failed to update.`);
			}).finally(() => {
				this.$emit('saving-done');
				this.loading = false;
			});
		},
		onResize() {
			if (this.singleEdit) {
				// Subtract the constant height of toolbar and bottom bar
				this.height = `${window.innerHeight - 56 - 64}px`;
			}
			else {
				this.height = '100%';
			}
		},
		checkArticleUrl() {
			axios.get(`/articles/check-url?url=${this.article.url}`).then((resp) => {
				this.iframeSrc = resp.data.status === 200 ? this.article.url : '';
			}).catch((e) => {
				dump('Error on request /articles/check-url', e);
				this.iframeSrc = '';
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.loading-bar {
	position: absolute;
}
#frame {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: none;
	background-color: transparent;
	transition-duration: 1s;
	transition-property: background-color;
}
.iframe-parent {
	position: relative;
	width: 100%;
	border: none;
	height: 100%;
	min-height: 80vh;
}
.iframe-loading {
	background-color: #fff !important;
}
.iframe-failed {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	text-align: center;
}
.edit-scrollable {
	overflow-y: auto;
}
.position-end {
	position: absolute;
	right: 0;
	bottom: 3px;
}
.fixed--top-right {
	position: fixed;
	right: 65px;
	top: 7px;
}
</style>
